import { useTranslation } from "react-i18next"
import { modifiers } from "ui-tools"
import { FiestaLink } from "utility-components"
import s from "./DueAndOverdue.module.scss"

export const DueAndOverdue = ({
  isActive,
  variant,
  count,
}: {
  isActive: boolean
  count: number
  variant: "overdue" | "due"
}) => {
  const { t } = useTranslation()

  return (
    <FiestaLink
      className={modifiers(s, "dueAndOverdue", variant, { isActive })}
      search={(search) => ({
        ...search,
        deadline_status: isActive ? undefined : variant,
      })}
    >
      <div className={s.dueAndOverdue__count}>{count}</div>
      {variant === "due" ? t("user.DUE_DATE") : t("user.OVERDUE")}
    </FiestaLink>
  )
}
